import http from '@/utils/request';

// 手动清分下载模板-百布专用清分下载模板
export const bbDivideDownload = '/receipt/divide/manage/bbDivideDownload';

// 商户列表-手动清分-百布专用手动清分
export const bbDivideUpload = (data) => {
  return http.post({
    url: '/receipt/divide/manage/bbDivideUpload',
    data,
  });
};
